import { jsx as h } from "react/jsx-runtime";
import k from "../../ui-kit/theme-button.mjs";
import { BadRequest as S } from "@systemeio/util";
import { useLoadPaypalScript as b } from "./use-load-paypal-script.mjs";
import { useStore as B } from "../../store/index.mjs";
import { buyOffer as F } from "../../pages/checkout/api/index.mjs";
function g({
  isFetching: p,
  buttonTitle: s,
  buttonDisabled: u,
  setIsFetching: t,
  preSubmit: w,
  handleBadRequest: m
}) {
  const { locale: f } = B(), { isScriptLoading: d } = b();
  return /* @__PURE__ */ h(
    k,
    {
      onClick: async (y) => {
        var r, a, e, i, n;
        y.preventDefault(), t(!0);
        try {
          const o = w();
          if (!o) return;
          (r = window.paypal) == null || r.checkout.initXO();
          const { redirect: c, approvalUrl: l } = await F(o, f);
          if (!l) {
            (a = window.paypal) == null || a.checkout.closeFlow(), c && window.location.assign(c);
            return;
          }
          (e = window.paypal) == null || e.checkout.startFlow(l);
        } catch (o) {
          if (o instanceof S)
            m(o), (i = window.paypal) == null || i.checkout.closeFlow();
          else
            throw (n = window.paypal) == null || n.checkout.closeFlow(), o;
        } finally {
          t(!1);
        }
      },
      isFetching: p,
      disabled: d || u,
      type: "submit",
      children: s
    }
  );
}
export {
  g as PaypalSoapPaymentButton
};
